import { useDispatch } from "react-redux";
import { Link, useParams, useHistory } from "react-router-dom";
import Popup from 'reactjs-popup';
import { useModel, useModels, useModelsApi } from "../../hooks/useModel";
import { useProjectId } from "../../hooks/useProjectId";
import { TextFrame, VerifyFrame } from "../modal-dialog/VerifyFrame";
import { LeftMenu } from "../nav/LeftMenu";
import { Main } from "../nav/Main";
import { EditModel } from "./EditModel";
import { NewModel } from "./NewModel";


export const Models = (props) => {

    const { project_id, subscription_id } = useProjectId();
    const dispatch = useDispatch();

    const routerParams = useParams();
    const selectedItemId = routerParams.id;
    const history = useHistory();

    const api = useModelsApi();
    
    const [items, itemsLoading, itemsError] = useModels();
    const [selectedItem] = useModel(selectedItemId);

    const closeLeftMenu = () => {
        //dispatch({ type: "LEFT_MENU_OPEN_SET", value: false });
    }

    return <>
        
        <LeftMenu>
            <div className='title'>
                Models
            </div>
            <div className='top-section'>

            </div>
            <div className='scroller'>
                <div className='summary'>
                    <p>
                        Description here for models.
                    </p>
                </div>
                {
                    itemsError ? <div className='list-content error'>Error loading models</div> :
                    itemsLoading ? <div className='list-content'>Loading...</div> :
                    !items ? null :
                    [...items]
                        .sort((a, b) => a.label?.localeCompare(b.label))
                        .map(item => <div key={item.id} className={`menu-item ${item.id === selectedItemId ? 'sel' : ''}`}>
                            <span className='grip'>
                                <i className='fal fa-cube' />
                            </span>
                            <Link
                                className='label'
                                to={`/subscription/${subscription_id}/project/${project_id}/model/${item.id}`}
                                onClick={() => closeLeftMenu()}
                            >
                                {item.label}
                            </Link>
                            <Popup
                                nested
                                contentStyle={{ padding: '0px' }}
                                trigger={<span className='menu' ><i className='far fa-ellipsis-h' /></span>}
                                position="right top">
                                {closeMenu => <ul className='popup-menu'>
                                        <Popup modal trigger={
                                            <li>Rename</li>
                                        }>
                                            {closeModal => <TextFrame
                                                title={"Rename model"}
                                                label={item.label}
                                                initialTextValue={item.label}
                                                close={closeModal} confirmed={async (text) => {
                                                    const newItem = {
                                                        ...selectedItem,
                                                        label: text
                                                    };
                                                    await api.updateItem(item.id, newItem);
                                                }}
                                            />}
                                        </Popup>
                                    
                                        <Popup modal trigger={
                                            <li>Delete model</li>
                                        }>
                                            {closeModal => <VerifyFrame
                                                title={"Delete model"}
                                                label={item.label}
                                            close={closeModal}
                                            confirmed={async () => {
                                                await api.deleteItem(item.id);
                                                // navigate away?
                                            }}
                                        />}
                                        </Popup>
                                </ul>}
                            </Popup>
                        </div>)
                }
                <div className='menu-item-stub center'>
                    <Popup
                        modal
                        trigger={
                            <div className="btn action" >
                                <i className='glyph fal fa-plus' /> New model
                            </div>
                        }>
                        {close => <NewModel close={close} onNew={(itemInfo) => {
                            history.push(`/subscription/${subscription_id}/project/${project_id}/model/${itemInfo.newId}`);
                        }} />}
                    </Popup>
                </div>
                
            </div>
        </LeftMenu>

        <Main>
            {selectedItem ? <EditModel id={selectedItemId} /> : null}
        </Main>
    </>;


    
}

